import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { RouterModule } from "@angular/router";
import { AdministrationNavModule } from "@vp/administration/ui/nav";
import { FilterToolbarModule } from "@vp/shared/components/filter-toolbar";
import { TagSelectorModule } from "@vp/shared/components/tag-selector";
import { FormatDateStringPipeModule } from "@vp/shared/pipes/format-date-string";
import { NgxPermissionsModule } from "ngx-permissions";
import { UsersListComponent } from "./users-list.component";
import { UtilitiesModule } from "@vp/shared/utilities";

@NgModule({
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    NgxPermissionsModule,
    TagSelectorModule,
    FilterToolbarModule,
    AdministrationNavModule,
    FormatDateStringPipeModule,
    RouterModule,
    UtilitiesModule
  ],
  declarations: [UsersListComponent],
  exports: [UsersListComponent]
})
export class UsersListModule {}
